import React, { useContext, useEffect } from "react"

import PhaseFour from "./PhaseFour.tsx"
import PhaseOne from "./PhaseOne.tsx"
import PhaseThree from "./PhaseThree.tsx"
import PhaseTwo from "./PhaseTwo.tsx"
import { Phase } from "../../types.ts"
import { OrderContext } from "../../OrderContext.tsx"
import { filledb2cOrder } from "../../data.ts"
import { calculateComsumptionEstimate } from "../../../../../misc/helpers.ts"
import ABTestContainer from "../Common/ABTestContainer.tsx"

function B2C({ currentPhase }: { currentPhase: Phase }) {
  const { formValues, setFormValues } = useContext(OrderContext);

  useEffect(() => {
    // Calculate consumption estimate when apartment size, electric sauna or electric heating changes
    const area = formValues['apartment-size'];
    let consumption = 0;
    if (area) {
      consumption = calculateComsumptionEstimate({
        area,
        apartmentType: formValues['apartment-type'],
        electricSauna: formValues['electric-sauna'],
        electricHeating: formValues['electric-heating']
      });
    }
    setFormValues({ ...formValues, 'consumption-estimate': consumption.toString() });
  }, [formValues['apartment-size'], formValues['electric-sauna'], formValues['electric-heating']]);

  useEffect(() => {
    // prefillData();
  }, [])

  const prefillData = () => {
    setFormValues(filledb2cOrder)
  }

  const variations = [
    { variationId: '1004370527', component: <PhaseThree /> },
    { variationId: '1004370528', component: <PhaseThree emptyValueByDefault={true} />}
  ]

  return (
    <>

      {currentPhase.value === 'kohde' && (
        <PhaseOne />
      )}

      {currentPhase.value === 'sopimus' && (
        <PhaseTwo />
      )}

      {currentPhase.value === 'palvelut' && (
        <ABTestContainer experimentId="1004156824" defaultVariationId="1004370527" variations={variations} fallback={<PhaseThree />} />
      )}

      {currentPhase.value === 'yhteenveto' && (
        <PhaseFour />
      )}
    </>
  );
}

export default B2C;
